import { useIntl } from 'react-intl';
import { Queue } from '@rossum/api-client/queues';
import { Header, HeaderProps } from '@rossum/components/header/Header';
import { QueueSettingsBreadcrumbs } from '../components/QueueSettingsBreadcrumbs';
import { QueueSettingsTabs } from '../components/QueueSettingsTabs';

type EmailsHeaderProps = {
  parentPath: string;
  queue: Queue;
  workspaceName: string;
} & Pick<HeaderProps, 'scrollableDivRef'>;

export const EmailsHeader = ({
  parentPath,
  queue,
  workspaceName,
  scrollableDivRef,
}: EmailsHeaderProps) => {
  const intl = useIntl();

  return (
    <Header
      scrollableDivRef={scrollableDivRef}
      tabs={<QueueSettingsTabs value="emails" parentPath={parentPath} />}
      breadcrumbs={
        <QueueSettingsBreadcrumbs
          queue={queue}
          workspaceName={workspaceName}
          breadcrumbs={[
            {
              label: intl.formatMessage({
                id: 'containers.settings.queues.queue.emails',
              }),
            },
          ]}
        />
      }
      title={intl.formatMessage({
        id: 'containers.settings.queues.queue.emails',
      })}
      description={intl.formatMessage({
        id: 'containers.settings.queues.queue.emails.description',
      })}
    />
  );
};
